export default __webpack_public_path__ + "7e5b11ef642fd422cebe4600da5f9f72.svg";